module.exports = new __parcel__URL__("Sync.06f454f4.svg").toString();